export enum CompanyQueryKeys {
  CompaniesByTypes = 'companiesByTypes'
}
